<script setup lang="ts">
import { Toasts } from '@laravel-inertia-toast/vue';
import AuthLayout from '@/layouts/auth/AuthSimpleLayout.vue';

const { title = '', description = '' } = defineProps<{
    title?: string;
    description?: string;
}>();
</script>

<template>
    <div>
        <AuthLayout :title="title" :description="description">
            <slot />
        </AuthLayout>
        <Toasts />
    </div>
</template>
